var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionCoordinatesLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_coordinates_location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    opacity: 0.78,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7192 9.63687C20.6574 5.25453 16.7088 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C13.3323 22 14.6037 21.7395 15.7661 21.2666C15.6373 21.0971 15.5065 20.9205 15.3754 20.7378C14.8348 19.9849 14.2623 19.0925 13.8181 18.1566C13.7499 18.0127 13.6827 17.8639 13.618 17.7107C13.0993 18.6944 12.5191 19.4575 12.037 19.9999L12 20L11.9628 19.9999C11.2303 19.1759 10.2715 17.8426 9.6459 16H13.0928C13.0339 15.6725 13 15.3377 13 15C13 14.6577 13.0272 14.3238 13.0795 14H9.15403C9.05565 13.3752 8.99988 12.7085 8.99988 12C8.99988 11.2915 9.05565 10.6248 9.15403 10H14.8457C14.8751 10.1868 14.9007 10.3773 14.9222 10.5716C15.9963 9.58718 17.4326 9 19 9C19.9758 9 20.9007 9.22757 21.7192 9.63687ZM7.51631 16C7.97544 17.6132 8.67286 18.758 9.32337 19.5413C7.52043 18.9013 6.01497 17.6331 5.07026 16H7.51631ZM7.11757 14H4.25203C4.08751 13.3608 4 12.6906 4 12C4 11.3094 4.08751 10.6392 4.25203 10H7.11757C7.04199 10.6162 6.99988 11.2818 6.99988 12C6.99988 12.7182 7.04199 13.3838 7.11757 14ZM7.51631 8H5.07026C6.01497 6.36687 7.52043 5.09869 9.32336 4.45875C8.67285 5.242 7.97544 6.38677 7.51631 8ZM9.6459 8C10.2715 6.15744 11.2303 4.82414 11.9628 4.00008L12 4L12.037 4.00008C12.7695 4.82414 13.7283 6.15744 14.3539 8H9.6459ZM16.4834 8C16.0243 6.38669 15.3268 5.24188 14.6763 4.45862C16.4794 5.09853 17.985 6.36676 18.9297 8H16.4834Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 22C19 22 23 17.8571 23 15C23 12.7143 21.2091 11 19 11C16.7909 11 15 12.7143 15 15C15 17.8571 19 22 19 22ZM19 17C20.1046 17 21 16.1046 21 15C21 13.8954 20.1046 13 19 13C17.8954 13 17 13.8954 17 15C17 16.1046 17.8954 17 19 17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionCoordinatesLocation);
export default __webpack_public_path__ + "static/media/ic_action_coordinates_location.8d81a26a4dd1bfd21b22bc908b21f003.svg";
export { ForwardRef as ReactComponent };